module.exports = __webpack_public_path__ + "static/media/tourney_list.7de84a01.png";